import { datadogRum } from '@datadog/browser-rum';

const HOST_MAP = {
  'reception.unitedtalent.com': 'prod',
  'reception.staging.unitedtalent.com': 'staging',
  'reception.qa.unitedtalent.com': 'dev',
  localhost: 'local',
};

/**
 * Initializes data dog for the appropriate host (environment)
 *
 * @param { string } host:
 * @param { string[] } allowableEnvs: a list of allowable environments to track.
 */
export const initializeDataDog = (host, allowableEnvs) => {
  const env = HOST_MAP[host];
  if (allowableEnvs.includes(env)) {
    datadogRum.init({
      env,
      version: '0.3.1',
      service: 'reception-united-talent',
      site: 'us3.datadoghq.com',
      applicationId: '8e650467-cdd0-42d8-bd76-3e773c6d394e',
      clientToken: 'pub505060f4d399ef68722a23b53e3bcaa8',
      allowedTracingOrigins: ['https://api.unitedtalent.com', /https:\/\/.*\.unitedtalent\.com/],
      sampleRate: 100,
      replaySampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'allow',
    });
  }
};
